import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class AccountClass {
  constructor(
    id = '',
    accountApproved = false,
    accountApprovedDate = new Date().toISOString(),
    accountApprovedUserId = '',
    created = new Date().toISOString(),
    email = '',
    emailVerified = false,
    emailVerifiedDate = new Date().toISOString(),
    emailVerifiedIsSend = false,
    emailVerifiedIsSendDate = new Date().toISOString(),
    firstName = '',
    isDeleted = false,
    isDeletedDate = new Date().toISOString(),
    isDeletedRemark = '',
    isDeletedUserId = '',
    isDisabled = false,
    isDisabledDate = new Date().toISOString(),
    isDisabledRemark = '',
    isDisabledUserId = '',
    lastName = '',
    phoneNumber = '',
    photoName = '',
    photoURL = '',
    roleDate = new Date().toISOString(),
    role = '',
    roleId = '',
    roleUserId = '',
    urlForgotPasswordEmail = '',
    urlVerificationEmail = '',
    settings = new AccountSettingClass(),
  ) {
    this.id = id;
    this.accountApproved = accountApproved;
    this.accountApprovedDate = accountApprovedDate;
    this.accountApprovedUserId = accountApprovedUserId;
    this.created = created;
    this.email = email;
    this.emailVerified = emailVerified;
    this.emailVerifiedDate = emailVerifiedDate;
    this.emailVerifiedIsSend = emailVerifiedIsSend;
    this.emailVerifiedIsSendDate = emailVerifiedIsSendDate;
    this.firstName = firstName;
    this.isDeleted = isDeleted;
    this.isDeletedDate = isDeletedDate;
    this.isDeletedRemark = isDeletedRemark;
    this.isDeletedUserId = isDeletedUserId;
    this.isDisabled = isDisabled;
    this.isDisabledDate = isDisabledDate;
    this.isDisabledRemark = isDisabledRemark;
    this.isDisabledUserId = isDisabledUserId;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.photoName = photoName;
    this.photoURL = photoURL;
    this.roleDate = roleDate;
    this.role = role;
    this.roleId = roleId;
    this.roleUserId = roleUserId;
    this.urlForgotPasswordEmail = urlForgotPasswordEmail;
    this.urlVerificationEmail = urlVerificationEmail;
    this.settings = settings;
  }

  static getClassName = () => {
    return 'Account - class';
  }

  static getClass = (obj = Object) => {
    if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName() })?.result) {
      return new AccountClass(
        obj?.id,
        obj?.accountApproved,
        obj?.accountApprovedDate,
        obj?.accountApprovedUserId,
        obj?.created,
        obj?.email,
        obj?.emailVerified,
        obj?.emailVerifiedDate,
        obj?.emailVerifiedIsSend,
        obj?.emailVerifiedIsSendDate,
        obj?.firstName,
        obj?.isDeleted,
        obj?.isDeletedDate,
        obj?.isDeletedRemark,
        obj?.isDeletedUserId,
        obj?.isDisabled,
        obj?.isDisabledDate,
        obj?.isDisabledRemark,
        obj?.isDisabledUserId,
        obj?.lastName,
        obj?.phoneNumber,
        obj?.photoName,
        obj?.photoURL,
        obj?.roleDate,
        obj?.role,
        obj?.roleId,
        obj?.roleUserId,
        obj?.urlForgotPasswordEmail,
        obj?.urlVerificationEmail,
        obj?.settings,
      );
    }

    return new AccountClass();
  }
}

class AccountSettingClass {
  constructor(
    aiApiKey = '',
  ) {
    this.aiApiKey = aiApiKey;
  }

   getClassName = () => {
    return 'Account settings - class';
  }

  getClass = (obj = Object) => {
    if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName() })?.result) {
      return new AccountSettingClass(
        obj?.aiApiKey,
      );
    }

    return new AccountSettingClass();
  }
}